import { Location } from 'history';
import { ApiPathConfig } from '../../api/api-path-config';

import { RoutesConfig } from '../../RoutesConfig';
import { fetchPageDetails, fetchPublicPages } from './actions';

export const publicActionCreators = [
  {
    path: RoutesConfig.public.publicTermsOverview.path,
    exact: true,
    action: fetchPublicPages,
  },
  {
    path: RoutesConfig.public.imprint.path,
    exact: true,
    action: () =>
      fetchPageDetails(ApiPathConfig.publicLegalNoticesShow('legalnotice')),
  },
  {
    path: RoutesConfig.public.legalPages.path,
    exact: true,
    action: ({ slug }: { slug: string }) =>
      fetchPageDetails(ApiPathConfig.publicOtherLegalPages(slug)),
  },
  {
    path: RoutesConfig.public.publicTermDetails.path,
    exact: true,
    action: ({ slug }: { slug: string }) =>
      fetchPageDetails(ApiPathConfig.publicTermsShow(slug)),
  },
];
